<template>
    <v-card flat>
        <!-- <v-card-title>
            <a v-if="devmode" @click="backClick()" class="text-subtitle-1"><v-icon small color="primary">mdi-chevron-left</v-icon>Back</a>
        </v-card-title> -->
        <slot name="header"></slot>
        <v-card-text>
            <slot></slot>
        </v-card-text>
        <v-card-actions>
            <slot name="actions">
                <v-spacer></v-spacer>
                <v-btn large color="primary" @click="backClick()" :disabled="backDisabled()">{{ backLabel }}</v-btn>
                <!-- <v-spacer></v-spacer> -->
                <v-btn large color="primary" @click="nextClick()" :disabled="nextDisabled()">{{ nextLabel }}</v-btn>
                <v-spacer></v-spacer>
            </slot>
        </v-card-actions>
    </v-card>
</template>

<script>
    import router from '@/router';

    export default {
        props: {
            backOverrideFunction: {
                type: Function,
                default: null
            },
            next: {
                type: String,
                default: null
            },
            nextLabel: {
                type: String,
                default: 'Next'
            },
            backLabel: {
                type: String,
                default: 'Back'
            },
            nextFunction: {
                type: Function,
                default: null
            },
            nextDisabled: {
                type: Function,
                default: () => false
            },
            backDisabled: {
                type: Function,
                default: () => false
            }
        },
        methods: {
            backClick() {
                if (this.backOverrideFunction) {
                    this.backOverrideFunction();
                } else {
                    router.back();
                }
            },
            nextClick() {
                let proceed = true;
                if (this.nextFunction) {
                    let ret = this.nextFunction();

                    if (!(ret || ret === undefined)) {
                        proceed = false;
                    }
                }

                if (proceed) {
                    router.push(this.next || `/m/${this.$route.params.module}/${this.page + 1}`).catch(() => {});
                }
            }
        },
        computed: {
            page() {
                return parseInt(this.$route.params.page) || 0;
            },
            devmode() {
                return localStorage.devmode;
            }
        }
    };
</script>
